import { render, staticRenderFns } from "./header_mobil.vue?vue&type=template&id=393ff67c"
import script from "./header_mobil.vue?vue&type=script&lang=js"
export * from "./header_mobil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports